export const STRINGS = {
  buttons: {
    belongPros: 'Use Belong Pros',
    myPro: 'Use My Pro',
  },
  manageMyself: 'I WANT TO MANAGE THIS PRO MYSELF.',
  cta: {
    next: 'Next',
    saveAndClose: 'Save & Close',
  },
  picker: {
    title: 'Which Pro should we call?',
    subtitle:
      "We'll get in touch to align on scope, check they're licensed and insured, and agree on a price before proceeding.",
    label: 'Your Pro',
    addNew: 'ADD NEW PRO',
    moreTrades: '+{count} More',
  },
  form: {
    title: "Let's meet your Pro!",
    titleFromPicker: "Who's your Pro?",
    subtitle:
      "Share their details and we'll get in touch to align on scope, check they're licensed and insured, and agree on a price before proceeding.",
    firstName: 'First Name',
    lastName: 'Last Name',
    company: 'Company (Optional)',
    phone: 'Phone',
    email: 'Email',
    or: 'OR',
    backToPicker: 'Back to your Pros',
  },
  warning: {
    title: 'Warning',
    exit: "You're about to exit the Belong system, proven to work for thousands of Homeowners looking for reduced vacancy and guaranteed\u00a0rent.",
    consequences:
      'While we understand there are reasons you may want to do this work yourself, please note that by selecting this option, parts of the Belong system will no longer function. In our experience, this option typically results in delays that increase vacancy, and quality issues that require additional repairs (often damaging the relationship with your future Residents).',
    alternative:
      'Alternatively, if you would like us to work with a specific licensed vendor, we would be happy to do so, and handle the entire experience end\u2011to\u2011end.',
  },
  validation: {
    required: 'Required',
    phone: 'Invalid phone number',
    email: 'Invalid email address',
    contact: 'Add a phone number or an email',
    proRequired: "Add your Pro's details to continue",
  },
  card: {
    belongPro: 'Use Belong Pro',
    ownPro: 'Use My Pro',
    homeownerFixing: 'Do It Myself',
    discuss: "Let's discuss",
  },
  summary: {
    title: '{count} {itemTitle} With Your {pro}',
    quotePendingPrefix: 'The ',
    quotePendingEmphasis:
      '{total} Never Exceed total does not include the {count} {item} you selected for your {pro}',
    quotePendingRest:
      ". Confirm the rest of the work now and we'll get started. Once we receive their quotes, we'll send them to you for final approval.",
    neutral:
      "Confirm the work now and we'll get started. We'll reach out to your {pro} to align on scope and price, and send their quotes to you for final approval.",
  },
  neverExceed: {
    excludes: 'Excludes',
    excludesRest: '{count} {item} with your {pro},',
    excludesQuoteNote: 'quoted separately for approval.',
    tooltip: 'It does not include {count} {item} selected for your {pro}.',
  },
} as const;
